import { useContext, useLayoutEffect, useRef, useState } from "react";
import { BurgerButtonBig, ButtonRound, DropdownInfo, HeaderBig, LearnMore, SignupBox } from "../common/Common";
import './ForFamilies.css';
import { LocaleContext } from "../common/App";
import { Footer, ForFamiliesSteps, PricingText } from "./WebsiteCommon";
import { useIndexUpdate, useNavigateSmart } from "../common/hooks";
import { UserType } from "../common/enums.mjs";
import { WebsiteContext } from "./WebsiteApp";

export function ForFamilies(props) {
    const locale = useContext(LocaleContext);
    const website = useContext(WebsiteContext);

    const navigate = useNavigateSmart();

    useIndexUpdate(props.indexUpdate, locale);

    return (
        <div className="for_families head_img">
            <img className="img_width" src="/customer/images/family_1.jpg" alt={locale.msgs.FAMILY_IMG_1_ALT_TEXT}></img>
            <div className="text_box">
                <h1 className="text_big_big head_after_img">{locale.msgs.FOR_FAMILIES_LONG}</h1>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.FOR_FAMILIES_DESCR}}></div>

                <div className="text_big_big margin_top_middle">{locale.msgs.HOW_BROKERAGE_WORKS}</div>
            </div>

            <img className="img_width margin_top_low_low" src="/customer/images/family_2.jpg" alt={locale.msgs.FAMILY_IMG_2_ALT_TEXT}></img>

            <div className="text_box">
                <ForFamiliesSteps/>
            </div>

            <div className="text_box">
                <div className="text_big_big margin_top_middle">{locale.msgs.AMOUNT_OF_FEES}</div>
                <PricingText />

                <div className="text_big_big margin_top_middle">{locale.msgs.YOU_ARE_EMPLOYERS}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.YOU_ARE_EMPLOYERS_DESCR}}></div>

                <div className="margin_top_high">
                    <SignupBox header={locale.msgs.FIND_MANNY_OR_NANNY_2} descr={locale.msgs.FIND_MANNY_OR_NANNY_DESCR_FAMILIES}
                        onClick={() => {
                            website.setRegisterInfo({...website.registerInfo, "userType": UserType.FAMILY});
                            navigate("/register/");
                        }} />
                </div>
            </div>
            
            <img className="img_width margin_top_high margin_bottom_high" src="/customer/images/family_3.jpg" alt={locale.msgs.FAMILY_IMG_3_ALT_TEXT}></img>

            {/*
            <div className="text_box_gray margin_bottom_high">
                <div className="text_big_big">{locale.msgs.OUR_ACADEMY}</div>
                <div className="text">{locale.msgs.OUR_ACADEMY_DESCR}</div>
                <LearnMore href="/login/"/>
            </div>
            */}

            <Footer />
        </div>
    );
}
